import React from "react";
import brazilFacialImg from "./../../../../Images/FacialPage/Brazilian Skin Lightening.png";

const BrazilianFacialImg = () => {
  return (
    <div className="facialExtImg">
      <img src={brazilFacialImg} alt="brazilFacialImg" />
    </div>
  );
};

export default BrazilianFacialImg;
